//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import PosSaleListView from '@/views/POS/PosSale/list'
import PosSaleUpdateView from '@/views/POS/PosSale/update'

/**
 *
 */
export default {
    path: 'pos_sales',
    component: ModuleLayout,
    children: [
        {
            name: 'pos-sale',
            path: '',
            component: PosSaleListView,
        },
        {
            name: 'pos-sale-update',
            path: ':id',
            component: PosSaleUpdateView,
            meta: {
                title: 'Datos del ticket de venta',
            },
        },
    ],
    meta: {
        title: 'Tickets de venta',
    },
}
